import { Button } from '@components/ui/Button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@components/ui/Dialog';
import { useGetDocumentMovementsQuery } from '@store/skeletor/documents/movements/getDocumentsMovements';
import { splitRut } from '@utils/rut/splitRut';

import { DocumentTimeLine } from '../DocumentTimeLine';
import { type ActionCellProps } from './types';

const ActionCell = ({
  clientRut,
  documentNumber,
  documentState,
}: ActionCellProps) => {
  const { data, isLoading } = useGetDocumentMovementsQuery({
    clientRut: splitRut(clientRut)[0],
    documentNumber: documentNumber.toString(),
    documentType: '1',
  });

  return (
    <div className="flex space-x-2">
      <Dialog>
        <DialogTrigger asChild>
          <Button
            id="btn-collection-action-cell-documents-data-table"
            size="xs"
          >
            Cobranza ({data?.length ?? 0})
          </Button>
        </DialogTrigger>
        <DialogContent className="max-w-[700px]">
          <DialogHeader>
            <DialogTitle>Actividad Cobranza</DialogTitle>
          </DialogHeader>
          <DialogDescription className="grid">
            <span>Numero documento: {documentNumber}</span>
            <span>Estado: {documentState}</span>
          </DialogDescription>
          <DocumentTimeLine isLoading={isLoading} documentMovements={data} />
        </DialogContent>
      </Dialog>
    </div>
  );
};

export { ActionCell };
